





















import { Component, Vue } from 'vue-property-decorator'
import { DisplayField, DisplayType } from './types'
import JsonTable from '@/components/ui/DynamicTechTaskCard/JsonTable.vue'


@Component({
    components: { JsonTable }
})
export default class DisplayFields extends Vue {
    DisplayType = DisplayType

    get displayFieldMapping(): { [key: string]: DisplayField } {
        const displayFieldMapping: { [key: string]: DisplayField } = {}
        for (const displayField of this.displayFields) {
            displayFieldMapping[displayField.key] = displayField
        }
        return displayFieldMapping
    }

    get displayFields() {
        return this.$store.getters.displayFields
    }

    get displayData() {
        return this.$store.state.techTask.displayData || {}
    }

    shouldShow(key: string): boolean {
        const displayField = this.displayFieldMapping[key] as DisplayField
        // If we have dependency options, check if we should show or hide the field.
        if (displayField.dependencyOptions) {
            for (const hideOnValue of displayField.dependencyOptions.hideOn) {
                if (hideOnValue === this.displayData[displayField.dependencyOptions.dependsOn]) {
                    return false
                }
            }
        }

        // Display by default.
        return true
    }
}
